import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'
import Message from '@/components/message'
Vue.config.productionTip = false
Vue.use(VueClipboard,Message)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: 'dist/error.png',
  loading: require('./assets/loadding.gif'),
  attempt: 10
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
